export default class Trait {
}
